import React from "react";
import NailSalonTestimonialCard from "../../NaliSalonPage/NailSalonTestimonial/NailSalonTestimonialCard";

const FacialTestimonialsMain = () => {
  return (
    <div className="nailTestimonialMainContainer">
      <NailSalonTestimonialCard
        para=" The best facials services in Bangalore! I’ve tried several facials at SCENT Salon, and they never disappoint. The Luxury Diamond Facial is my favorite—it leaves my skin feeling so hydrated and plump. The team at SCENT Salon is fantastic!"
        name="- Priya S"
      />
      <NailSalonTestimonialCard
        para="I booked a hydrating facial for my wife, and she loved it! Her skin looked so radiant and glowing after the treatment. The salon has a very relaxing ambiance, and the staff is very attentive. We will definitely be coming back "
        name="- Ravi K"
      />
      <NailSalonTestimonialCard
        para=" I had the Ainhoa Kronoage Caviar Facial, and it was amazing! My skin felt so soft and rejuvenated afterward. The staff was very professional and made me feel comfortable throughout the treatment. Highly recommend SCENT Salon for facials services in Bangalore!"
        name="- Ananya P"
      />
    </div>
  );
};

export default FacialTestimonialsMain;
